export default "__VITE_ASSET__DbDhkemW__"